import { Theme } from '@mui/material/styles'
import { palette } from 'c1ui'
import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const styles: moduleStyleType = {
    root: {
        fontSize: 13,
        '& .MuiAutocomplete-option': {
            pl: 1,
            pr: 1,
            pt: 0,
            pb: 0,
        },
        '& .MuiButton-outlined': {
            borderColor: 'divider',
        },
    },
    popper: {
        border: '1px solid rgba(27,31,35,.15)',
        boxShadow: '0 3px 12px rgba(27,31,35,.15)',
        width: 'auto',
        zIndex: 10,
        fontSize: 13,
        color: palette.grey[700],
        backgroundColor: 'background.default',
    },
    widePopper: {
        width: '22rem',
    },
    header: {
        borderBottom: `1px solid ${palette.divider}`,
        fontWeight: 600,
    },
    inputBase: {
        width: '100%',
        borderBottom: `1px solid ${palette.divider}`,
        '& .MuiSvgIcon-root': {
            mr: 2,
        },
        '& input': {
            backgroundColor: 'background.default',
            p: 2,
            transition: (theme: Theme): string =>
                theme.transitions.create(['border-color', 'box-shadow']),
            fontSize: 14,
            fontWeight: 500,
        },
    },
    paper: {
        color: palette.grey[700],
        fontSize: 13,
        borderRadius: 0,
    },
    option: {
        pl: 1,
        pr: 1,
        pt: 0,
        pb: 0,
        alignItems: 'center',
        fontWeight: 500,
        color: 'text.primary',
        m: 0,
        '&[aria-selected="true"]': {
            backgroundColor: 'transparent',
        },
        '&[data-focus="true"]': {
            backgroundColor: 'action.hover',
        },
        '& .MuiChip-label': {
            fontSize: 12,
            fontWeight: 450,
        },
    },
    popperDisablePortal: {
        position: 'relative',
    },
    close: {
        opacity: 0.6,
        width: 18,
        height: 18,
    },
    item: {
        display: 'flex',
        flexDirection: 'row',
    },
}
